import { faPlug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function online() {
    return (
        <div data-cy="history-online">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.online" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faPlug} style={{ color: 'green' }} size="lg" />
            </Whisper>
        </div>
    );
}
